import React, { useEffect } from 'react';
import { HardDrive, Database, Clock } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const BackupRecovery = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('backup-recovery');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'Backup Strategies',
      icon: HardDrive,
      description: 'Comprehensive backup planning, scheduling, and best practices for data protection.',
      scripts: getContentByCategory('Backup and Recovery', 'Backup Strategies')
    },
    {
      name: 'Recovery Procedures',
      icon: Database,
      description: 'Point-in-time recovery, disaster recovery procedures, and restoration techniques.',
      scripts: getContentByCategory('Backup and Recovery', 'Recovery Procedures')
    },
    {
      name: 'Backup Monitoring',
      icon: Clock,
      description: 'Monitor backup jobs, verify backup integrity, and automate backup reporting.',
      scripts: getContentByCategory('Backup and Recovery', 'Backup Monitoring')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Backup & Recovery</h1>
        <p className="page-description">
          Essential backup and recovery solutions for SQL Server environments. Protect your data 
          with proven backup strategies, recovery procedures, and monitoring techniques.
        </p>
      </div>

      <CategoryTabs 
        category="Backup and Recovery"
        scripts={getContentByCategory('Backup and Recovery')}
        articles={getContentByCategory('Backup and Recovery', null, 'articles')}
        faqs={getContentByCategory('Backup and Recovery', null, 'faqs')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default BackupRecovery;